import React from 'react';

/**
 * Card Component - TrackMan Pro Design System v1.0
 *
 * Variants:
 * - base: Standard card with border and subtle shadow
 * - elevated: Card with enhanced shadow for hierarchy
 * - interactive: Card with hover effects (lift + glow)
 * - glass: Glassmorphism card with backdrop blur
 */

export const Card = ({
  children,
  variant = 'base',
  interactive = false,
  className = '',
  onClick,
  ...props
}) => {
  const baseStyles = 'bg-surface border rounded-lg transition-all duration-200';

  const variantStyles = {
    base: 'border-border',
    elevated: 'border-border shadow-md',
    interactive: 'border-border hover:-translate-y-1 hover:shadow-lg hover:shadow-primary/20 cursor-pointer',
    glass: 'border-border-subtle backdrop-blur-xl bg-surface/70',
  };

  // If interactive prop is true, override variant
  const finalVariant = interactive ? 'interactive' : variant;

  return (
    <div
      className={`${baseStyles} ${variantStyles[finalVariant]} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

/**
 * CardHeader - Optional header section for cards
 */
export const CardHeader = ({ children, className = '' }) => (
  <div className={`px-6 py-4 border-b border-border ${className}`}>
    {children}
  </div>
);

/**
 * CardBody - Main content area of card
 */
export const CardBody = ({ children, className = '' }) => (
  <div className={`px-6 py-6 ${className}`}>
    {children}
  </div>
);

/**
 * CardFooter - Optional footer section for cards
 */
export const CardFooter = ({ children, className = '' }) => (
  <div className={`px-6 py-4 border-t border-border flex justify-end gap-3 ${className}`}>
    {children}
  </div>
);

